export const en = {
    "ConfirmDelete": "Are you sure you want to delete this record?",
    "OK": "OK",
    "Cancel": "Cancel",
    "Delete": "Delete"
}